import { useQuery } from '@mint-lib/query-client';
import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

const useFlowData = (flowId: string) => {
  return useQuery({
    ...ApprovalFlows.getFlow({
      urlParams: {
        flowId,
      },
    }),
    select: (data) => data.data?.items[0],
  });
};

export default useFlowData;
